<template>
  <div class="date-picker">

    <i class="el-icon-arrow-left" @click="changeDay(-1)"></i>
    <el-date-picker
        :picker-options="pickerOptions"
        v-model="date"
        type="date"
        format="dd.MM.yyyy"

        placeholder="Выберите дату"
        @change="changeDate"
    />

    <i class="el-icon-arrow-right" @click="changeDay(+1)"></i>
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    value: {}
  },
  components: {},
  data: () => ({
    pickerOptions: {
      firstDayOfWeek: 1
    },
    date: null

  }),
  watch: {
    value(value) {
      this.date = value
    }
  },
  computed: {},
  methods: {
    changeDay(days) {
      let date = new Date(this.date)
      date.setDate(date.getDate() + days)
      this.changeDate(date)
    },
    changeDate(value) {

      if (value === null) value = new Date()

      this.$emit('change', value)
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>

.date-picker {
  max-width: 182px;
  margin-left: 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  /deep/ {
    .el-input__prefix {
      display: none;
    }

    .el-date-editor.el-input {
      max-width: 118px !important;
    }

    .el-input__inner {
      padding: 0 10px !important;
      font-weight: 600 !important;
      font-size: 16px !important;
      line-height: 1 !important;

      color: #676767 !important;

      background: transparent !important;
      border: none !important;

    }
  }

}

</style>